<div class="top-corner">
  <div style="float:left" class="input-group">
    <a class="navbar-item">
    </a>
  </div>
</div><br>
<div class="login-form col-md-12">
  <form [formGroup]="recoverForm">
    <h4 class="text-center">{{ "TITLE.PASSWORD-RECOVERY" | translate }}</h4>
    <p class="text-center">{{ "MESSAGE.ENTER-USERNAME-TO-START-PASSWORD-RECOVERY-PROCESS" | translate }}</p>
    <div class="separator"></div>
    <div class="form-group mt-1">
      <input type="text"
             class="form-control"
             formControlName="username"
             [(ngModel)]="username"
             [class.is-invalid]="isInvalidControl('username')"
             (keyup.enter)="doIt()"
             placeholder="{{ 'MESSAGE.USER-NAME' | translate }}"
             required="required">
      <small *ngIf="isInvalidControl('username')"
             class="text-danger">
        {{this.actualValue}}{{getErrorMessageBy('username') | translate}}
      </small>
    </div>
    <div class="form-group">
      <button type="button" class="btn btn-success w-100" (click)="doIt()"><i class="fa fa-chevron-circle-right" aria-hidden="true"></i> {{ "BUTTON.NEXT" | translate }}</button>
     <br>
      <div class="text-center">
        <small>{{ "MESSAGE.FOR-LOGIN-USING-USERNAME-AND-PASSWORD-CLICK" | translate }} <a [routerLink]="'/login'">{{ "LINK.HERE" | translate }}</a></small>
      </div>
    </div>
  </form>
</div>
<app-loading *ngIf="loading"></app-loading>
